import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

import { OfferRecord, ProductRecord } from 'internal-components/src/records'
import Currency from 'internal-components/src/components/Currency'

import Features from './Features'
import ProductIcon from '../Product/Icon'
import {connect} from "react-redux";
import {makeSelectProduct} from "../../../deps/internal-components/src/redux/modules/product/selectors";

function Offer({
  compact = false,
  offer,
  onClick,
  product,
  selected = false,
}) {
  const offerClasses = cx(
    'offer',
    'thumbnail',
    offer.get('attributes').toArray(),
    { selected },
  )

  let ribbon
  if (!compact && offer.get('attributes').has('popular')) {
    ribbon = (
      <div className="ribbon">
        <span>Popular</span>
      </div>
    )
  }

  const hasVisionIntroOffer = false;

  const priceByExtensions = offer.attributes.has('price_by_extensions');

  return (
    <a
      role="button"
      tabIndex={0}
      className={offerClasses}
      onClick={onClick}
      data-uniqueId={offer.uniqueId}
    >
      {ribbon}

      {!compact && product && <ProductIcon product={product} />}

      <div className="caption">
        <h3>{offer.get('name')}</h3>

        <div className="price">
          <strong>
            <Currency amount={offer.get('recurringAmount')} />
          </strong>
          <small>
            {priceByExtensions && '/extension'}
            /{offer.get('period').humanize().replace(/^a /, '')}
          </small>
        </div>
        {hasVisionIntroOffer && <div className="price">
          <strong>
            <Currency amount={offer.recurringAmount - 20}/>
          </strong><small>/month for 12 months</small>
        </div>}
        <div className="setup">
          <small>
            <Currency amount={offer.get('setupAmount')}/> setup
          </small>
        </div>
        <div className="minimumSpend">
          <small>
            <Currency amount={offer.get('minimumSpend') - (hasVisionIntroOffer ? 20 : 0)} /> minimum spend
          </small>
        </div>

        <Features offer={offer} product={product} />
      </div>
    </a>
  )
}

Offer.propTypes = {
  compact: Pt.bool,
  offer: Pt.instanceOf(OfferRecord).isRequired,
  onClick: Pt.func.isRequired,
  product: Pt.instanceOf(ProductRecord).isRequired,
  selected: Pt.bool,
}


export const makeMapStateToProps = () => {
  const selectProduct = makeSelectProduct()

  return (state, ownProps) => ({
    product: selectProduct(state, {
      productId: ownProps.offer.product,
    }),
  })
}

export default connect(makeMapStateToProps)(Offer)



// WEBPACK FOOTER //
// ./src/components/OfferSelector/Offer.jsx